import type { ActivityModule } from '../../core/activity';
import { mountMoneyBackCents } from './ui';
import levelsData from './levels.json';
import '../money/style.css';
import '../money_back/style.css';
import '../money_cents/style.css';

export const moneyBackCents: ActivityModule = {
  id: 'money_back_cents',
  title: 'Troco com centavos',
  description: 'Devolva o troco em moedas e notas — agora com centavos.',
  ageMin: 9,
  ageMax: 12,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/money_back_cents/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountMoneyBackCents,
};
